(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-valentines-day-two"] && !Shopify.designMode) return;
  try {
    
   // ... (JS 部分保持不变) ...
    function getNextValentine() {
        const now = new Date();
        const year = now.getFullYear();
        let val = new Date(year, 1, 14, 0, 0, 0);
        if (now > val) val = new Date(year + 1, 1, 14, 0, 0, 0);
        return val;
    }

    const targetDate = getNextValentine();

    function pad(num) {
        return num < 10 ? '0' + num : num.toString();
    }

    function scrollUpdate(el, newValue) {
        const currValue = el.getAttribute('data-curr-two');
        if (newValue === currValue) return;

        const strip = el.querySelector('.scroll-strip-two');
        const newNumDiv = document.createElement('div');
        newNumDiv.className = 'scroll-num-two';
        newNumDiv.innerText = newValue;

        strip.prepend(newNumDiv);
        strip.style.transition = 'none';
        strip.style.transform = 'translateY(-50%)';

        void strip.offsetHeight;

        strip.style.transition = 'transform 0.6s cubic-bezier(0.34, 1.56, 0.64, 1)';
        strip.style.transform = 'translateY(0)';

        el.setAttribute('data-curr-two', newValue);

        setTimeout(() => {
            strip.style.transition = 'none';
            if (strip.children.length > 1) {
                strip.lastElementChild.remove();
            }
        }, 600);
    }

    function updateCountdown() {
        const now = new Date();
        const diff = targetDate - now;
        if (diff <= 0) return;

        const d = Math.floor(diff / (1000 * 60 * 60 * 24));
        const h = Math.floor((diff / (1000 * 60 * 60)) % 24);
        const m = Math.floor((diff / 1000 / 60) % 60);
        const s = Math.floor((diff / 1000) % 60);

        scrollUpdate(document.getElementById('days-two'), pad(d));
        scrollUpdate(document.getElementById('hours-two'), pad(h));
        scrollUpdate(document.getElementById('minutes-two'), pad(m));
        scrollUpdate(document.getElementById('seconds-two'), pad(s));
    }

    setInterval(updateCountdown, 1000);
    updateCountdown();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-valentines-day"] && !Shopify.designMode) return;
  try {
    
  // JS 逻辑保持 V6 版本不变 (已包含无闪烁修复)
  function getNextValentine() {
      const now = new Date();
      const year = now.getFullYear();
      let val = new Date(year, 1, 14, 0, 0, 0);
      if (now > val) val = new Date(year + 1, 1, 14, 0, 0, 0);
      return val;
  }

  const targetDate = getNextValentine();

  function pad(num) {
      return num < 10 ? '0' + num : num.toString();
  }

  function flip(el, newValue) {
      const currValue = el.getAttribute('data-curr');
      if (newValue === currValue) return;

      const staticTop = el.querySelector('.static-top span');
      const staticBottom = el.querySelector('.static-bottom span');
      const leaf = el.querySelector('.leaf');
      const leafFront = el.querySelector('.leaf-front span');
      const leafBack = el.querySelector('.leaf-back span');

      staticTop.innerText = newValue;
      staticBottom.innerText = currValue;
      leafFront.innerText = currValue;
      leafBack.innerText = newValue;

      leaf.classList.remove('flipping');
      void leaf.offsetWidth;
      leaf.classList.add('flipping');

      setTimeout(() => {
          el.setAttribute('data-curr', newValue);
          staticBottom.innerText = newValue;
          // 无闪烁逻辑：先改字，再复位
          leafFront.innerText = newValue;
          leafBack.innerText = newValue;
          leaf.classList.remove('flipping');
      }, 600);
  }

  function updateCountdown() {
      const now = new Date();
      const diff = targetDate - now;

      if (diff <= 0) return;

      const d = Math.floor(diff / (1000 * 60 * 60 * 24));
      const h = Math.floor((diff / (1000 * 60 * 60)) % 24);
      const m = Math.floor((diff / 1000 / 60) % 60);
      const s = Math.floor((diff / 1000) % 60);

      flip(document.getElementById('days'), pad(d));
      flip(document.getElementById('hours'), pad(h));
      flip(document.getElementById('minutes'), pad(m));
      flip(document.getElementById('seconds'), pad(s));
  }

  setInterval(updateCountdown, 1000);
  updateCountdown();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
